import { Modal, P, Stack, TextField } from "@ovotech/element";
import React, { ChangeEvent, useRef } from "react";
import { Formy, FormApi } from "_core/form";
import { getPostcodeValidator, FormValues } from "_core/validators/Postcode";
import "./postcodeModal.module.css";

export const PostcodeModal = ({
  isOpen,
  onClose,
  postcode,
  setPostcode,
}: {
  isOpen: boolean;
  onClose: () => void;
  postcode: string;
  setPostcode: (postcode: string) => void;
}) => {
  const formApiRef = useRef<FormApi<FormValues>>(null);
  const htmlFormRef = useRef<HTMLFormElement>(null);

  const handleSubmit = (submittedValues: FormValues) => {
    setPostcode(submittedValues.postcode);
    onClose();
  };

  return (
    <Modal
      className="PostcodeModal"
      title="Please confirm your postcode"
      primaryButton={{
        label: "Continue",
        onClick: () => {
          htmlFormRef.current?.requestSubmit();
        },
      }}
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={false}
    >
      <Formy
        ref={formApiRef}
        enableReinitialize
        initialValues={{ postcode: postcode ?? "" }}
        validationSchema={getPostcodeValidator}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit: formElementSubmitHandler,
          values,
          setFieldValue,
          touched,
          errors,
        }: FormApi<FormValues>) => {
          return (
            <form onSubmit={formElementSubmitHandler} ref={htmlFormRef}>
              <Stack spaceBetween={4}>
                <P size="lg">
                  We just need to match your postcode with your order
                </P>

                <TextField
                  label="Enter your postcode"
                  placeholder="Postcode"
                  id="postcode"
                  name="postcode"
                  value={values.postcode}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue("postcode", e.target.value);
                  }}
                  error={touched.postcode && errors.postcode}
                />
              </Stack>
            </form>
          );
        }}
      </Formy>
    </Modal>
  );
};
